import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { ImportOutlined } from "@ant-design/icons";
import { signout } from "../../../../helpers/auth";
import Card from "./Card";
import "../Home.css";

const Home = ({ history }) => {
  const [lightMode, setLightMode] = useState(() => {
    return localStorage.getItem('sakeenat-theme') === 'light';
  });

  useEffect(() => {
    localStorage.setItem('sakeenat-theme', lightMode ? 'light' : 'dark');
  }, [lightMode]);

  const handleSignOut = () => {
    signout(() => {
      history.push("/");
    });
  };

  return (
    <div className={`admin-home-container${lightMode ? ' light-mode' : ''}`}>
      <div className='admin-nav'>
        <div className='admin-title'>
          <span className='admin-title-icon'>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/>
            </svg>
          </span>
          Sakeenat Lectures
        </div>
        <div className='admin-nav-right'>
          <button className='al-theme-toggle' onClick={() => setLightMode(!lightMode)} title={lightMode ? 'Switch to dark mode' : 'Switch to light mode'}>
            <span className='al-theme-toggle-knob'>
              {lightMode ? (
                <svg viewBox="0 0 24 24" fill="none" stroke="#1a1a1a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
                </svg>
              ) : (
                <svg viewBox="0 0 24 24" fill="none" stroke="#121212" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/>
                </svg>
              )}
            </span>
          </button>
          <button className='admin-btn-signout' onClick={handleSignOut}>
            <ImportOutlined /> Sign Out
          </button>
        </div>
      </div>
      <h2 className="al-page-title">Tafseer ul Quran Class</h2>
      <Card />
    </div>
  );
};

export default withRouter(Home);
